var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadCloudSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload-cloud",
    clipPath: "url(#clip0_5550_10784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.8326 13.3313L10.4992 9.99795M10.4992 9.99795L7.1659 13.3313M10.4992 9.99795V17.498M17.4909 15.323C18.3037 14.8798 18.9458 14.1787 19.3158 13.3301C19.6858 12.4816 19.7627 11.534 19.5344 10.6369C19.3061 9.73974 18.7855 8.94421 18.0548 8.37582C17.3241 7.80744 16.425 7.49856 15.4992 7.49795H14.4492C14.197 6.52232 13.7269 5.61656 13.0742 4.84878C12.4215 4.08099 11.6033 3.47116 10.681 3.06512C9.7587 2.65909 8.75636 2.46742 7.74933 2.50452C6.7423 2.54162 5.75679 2.80654 4.86688 3.27934C3.97697 3.75214 3.20583 4.42054 2.61142 5.23427C2.01701 6.048 1.61481 6.9859 1.43505 7.97745C1.25529 8.969 1.30266 9.98839 1.57358 10.959C1.8445 11.9296 2.33194 12.8262 2.99923 13.5813",
    stroke: "#535862",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5550_10784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloudSvg);
export default __webpack_public_path__ + "static/media/UploadCloudSvg.f3574e179ffeef1ec86141f81cb1fda3.svg";
export { ForwardRef as ReactComponent };